import type { MouseEventHandler } from 'react';
import styled from 'styled-components';
import { Button, focusVisibleMixin } from '@elfsight/widget-ui';
import { getInvertedColor, openWindowByLink } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import type { PollSettings } from '../../types';

export function SuccessContainer() {
  const {
    textColor,
    accentColor,
    showSuccessMessage,
    successMessageText,
    showActionButton,
    actionButtonText,
    actionButtonLink
  } = useSettings();

  const handleClick: MouseEventHandler = (event) => {
    if (actionButtonLink.rawValue) {
      openWindowByLink(event, actionButtonLink);
    }
  };

  if (!showSuccessMessage && !showActionButton) {
    return;
  }

  return (
    <Container>
      {showSuccessMessage && (
        <Message
          _textColor={textColor}
          _focusColor={textColor}
          dangerouslySetInnerHTML={{
            __html: successMessageText
          }}
        />
      )}
      {showActionButton && (
        <Button
          color={accentColor}
          fontColor={getInvertedColor(accentColor)}
          font={{
            fontSize: 15,
            fontWeight: 700
          }}
          onClick={handleClick}
        >
          {actionButtonText}
        </Button>
      )}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  animation: appearance 0.5s ease forwards;

  @keyframes appearance {
    0% {
      margin-top: -32px;
      height: 0;
      opacity: 0;
    }
    50% {
      margin-top: 0;
      height: auto;
      opacity: 0;
    }
    100% {
      height: auto;
      opacity: 1;
    }
  }
`;

const Message = styled.div<{
  _textColor: PollSettings['textColor'];
  _focusColor: string;
}>`
  font-size: 16px;
  line-height: 1.375;
  text-align: center;
  color: ${({ _textColor }) => _textColor};

  & a {
    color: inherit;
    ${({ _focusColor }) => focusVisibleMixin(_focusColor)}
  }
`;
